(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/playtogether-selector.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/playtogether-selector.js'); 
'use strict';

svs.numbergames.game.views.PlayTogetherSelector = Marionette.View.extend({
  ui: {
    teamSelector: '#teamSelector'
  },
  triggers: {
    'change @ui.teamSelector': 'changeTeam'
  },
  modelEvents: {
    'change:isSubscription': 'onChangeIsSubscription'
  },
  className: 'playtogether-selector numbergames-footer-section',
  getTemplate() {
    return this.shouldRender() ? svs.numbergames.game.templates.playtogether_selector : false;
  },
  templateContext() {
    const teams = [{
      syndicateId: 'user',
      syndicateName: 'Mitt saldo',
      playableAmount: this.userBalance
    }];
    teams.push(...svs.syndicate.account_selector.data.syndicates);
    const currentSyndicateId = svs.syndicate.AccountSelector.getActiveAccountId();
    if (currentSyndicateId) {
      teams.forEach(team => {
        team.selected = team.syndicateId === currentSyndicateId;
      });
    }
    return {
      teams
    };
  },
  initialize() {
    if (svs.numbergames.game.utils.isSelfService()) return;

    if (this.model.get('isSyndicate')) {
      this.model.set({
        isSyndicate: false,
        syndicateId: 0
      });
    }
    if (svs.syndicate.core.collections.getSyndicateCollectionInstance().length) {
      this.syndicateCollection = svs.syndicate.core.collections.getSyndicateCollectionInstance();
    } else {
      this.syndicateCollection = svs.syndicate.core.collections.getSyndicateCollectionInstance().reset(svs.syndicate.account_selector.data.syndicates, {
        parse: true
      });
    }
    this.accountSelector = svs.syndicate.AccountSelector;
    this.currentUserAccountModel = this.accountSelector.getAccountModel();
    if (this.currentUserAccountModel.get('isSyndicate') || this.model.get('isSyndicate')) {
      const syndicateId = this.model.get('isSyndicate') ? this.model.get('syndicateId') : this.currentUserAccountModel.get('syndicateId');
      this.currentUserAccountModel.setSyndicate(svs.syndicate.core.collections.syndicates.findWhere({
        syndicateId
      }));
      this.accountSelector.setQueryString(syndicateId);
      this.model.set({
        isSyndicate: true,
        syndicateId
      });
    }
    if (this.model.has('prolongedBet') && this.model.get('prolongedBet').syndicateId && !this.model.get('isSyndicate')) {
      svs.numbergames.game.utils.dialogs.notActiveMemberProlongDialog();
    }
    svs.components.account_balance.get(true, balance => {
      this.userBalance = balance;
      this.render();
    });
  },
  onRender() {
    if (this.model.get('isSubscription')) this.getUI('teamSelector').prop('disabled', true);
  },
  shouldRender() {
    return this.userBalance && this.syndicateCollection.length && svs.syndicate.account_selector.data.canPlayAsSyndicate && svs.syndicate.account_selector.data.syndicates.length > 0;
  },
  onChangeTeam(view, event) {
    const selectedSyndicateId = event ? event.target.value : 'user';
    if (selectedSyndicateId === 'user') {
      this.accountSelector.getUserModel(userAccountModel => {
        this.currentUserAccountModel.setUser(userAccountModel.get('playableAmount'));
        this.accountSelector.setQueryString();
        this.model.set('syndicateId', 0);
      });
    } else {
      const syndicateId = parseInt(selectedSyndicateId, 10);
      this.currentUserAccountModel.setSyndicate(svs.syndicate.core.collections.syndicates.findWhere({
        syndicateId
      }));
      this.accountSelector.setQueryString(selectedSyndicateId);
      this.model.set('syndicateId', syndicateId);
    }
  },
  onChangeIsSubscription() {
    if (this.shouldRender()) {
      const $teamSelector = this.getUI('teamSelector');
      if ($teamSelector[0]) {
        $teamSelector.prop('disabled', this.model.get('isSubscription'));
        if (this.model.get('isSubscription') && $teamSelector[0].selectedIndex > 1) {
          $teamSelector.val('user');
          this.onChangeTeam();
        }
      }
    }
  },
  onDestroy() {
    this.model.set({
      isSyndicate: false,
      syndicateId: 0
    });
  }
});
 })(window);